import { useI18n } from 'vue-i18n';
import { object, string, number } from 'yup';

export default () => {
  // Set localization
  const { t } = useI18n();

  const multigroupSchema = string().optional().nullable();

  const defaultSchema = object().shape({
    id: string().optional().nullable(),
    name: string().required(t('errorMessages.required')),
    multigroup: multigroupSchema,
    label: object()
      .shape({
        en: string().optional().nullable(),
      })
      .optional(),
    address: object().shape({
      state: string().required(t('errorMessages.required')),
      zip: string().required(t('errorMessages.required')),
      country: string().required(t('errorMessages.required')),
      address: string().required(t('errorMessages.required')),
      city: string().required(t('errorMessages.required')),
      coordinates: object().shape({
        latitude: number().required(t('errorMessages.required')),
        longitude: number().required(t('errorMessages.required')),
      }),
    }),
    meta: object().shape({
      sector_name: string().required(t('errorMessages.required')),
    }),
  });

  return {
    defaultSchema,
  };
};
